import { Box, Typography, styled } from '@mui/material';
import React from 'react';
import { BudgetProposalT } from 'routes/BudgetModule/config/types';
import { AutocompletAble } from 'ui/DropdownItems/types';
import { getProjectionVentilationReadableValue } from '../helpers/dataHelpers';
import { useTranslation } from 'react-i18next';
import { ProjectionVentilation } from 'routes/BudgetModule/components/BudgetProposal/Resource/Projection/helpers/types';
import { ProjectionTypes } from 'routes/Admin/Budget/BudgetManagement/BudgetList/CellRenderers/constants';

const StyHighlight = styled(Box, {
    name: 'StyHighlight',
})(({ theme }) => ({
    fontWeight: 700,
    color: theme.palette.primary.main,
}));

const extractTableFromDimension = (value: string): string =>
    value.split('.')[0];

type VentilationConfirmationParagraphParams = {
    values: AutocompletAble<ProjectionVentilation.SoftwareIds>[]; //
    budgetProposal: BudgetProposalT;
    projectionType: ProjectionTypes;
    softwares: Set<string>;
};

/**
 * Component in charge of building a confirmation sentence paragraph displayed
 * when a user wants to modify a projection ventilation.
 * Content is adapter to projection type (pluriannual or atterrissage)
 */
export default function VentilationConfirmationParagraph({
    values,
    budgetProposal,
    projectionType,
    softwares,
}: VentilationConfirmationParagraphParams): React.ReactElement {
    const { t } = useTranslation();
    return (
        <Typography>
            {t(`budgetProposal.confirm${projectionType}Part1`)}{' '}
            <StyHighlight component="span">{budgetProposal.name}</StyHighlight>{' '}
            {t(`budgetProposal.confirm${projectionType}Part2`)}{' '}
            <StyHighlight component="span">
                {[
                    `${extractTableFromDimension(
                        budgetProposal!.by,
                    )}.softwareId`,
                    ...values.map((v) => v.value),
                ]
                    .map((v) =>
                        getProjectionVentilationReadableValue(v, softwares),
                    )
                    .join(' + ')}
            </StyHighlight>{' '}
            {t(`budgetProposal.confirm${projectionType}Part3`)}{' '}
        </Typography>
    );
}
